import { Button, Chip, CircularProgress, Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { request } from "@/Api";
import { useSearchParams } from "react-router-dom";
import { parseJwt } from "@/auth/authUtils";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import NumbersRoundedIcon from "@mui/icons-material/NumbersRounded";
import Confirmation from "@/public/Confirmation";
import InvoiceFormMulti from "./InvoiceFormMulti";

export default function InvoicePortalInvoiceMultiPage() {
    const [searchParams, _] = useSearchParams();

    const [orgLoading, setOrgLoading] = useState(false);
    const [organization, setOrganization] = useState(null);

    const token = searchParams.get("token");
    const publicId = searchParams.get("public_id");
    const tokenInfo = parseJwt(token);

    const getOrganization = () => {
        setOrgLoading(true);
        request
            .get("/organization-by-public-id", {
                params: { public_id: publicId },
            })
            .then((response) => {
                setOrganization(response.data);
            })
            .catch((error) => {
                setOrganization(null);
                console.error("Error fetching organization:", error);
            })
            .finally(() => {
                setOrgLoading(false);
            });
    };

    useEffect(() => {
        getOrganization();
    }, []);

    if (orgLoading) {
        return <Confirmation description={<CircularProgress />} />;
    }

    if (!organization) {
        return (
            <Confirmation
                description={
                    <p>
                        This invoice link is not tied to an organization, please
                        reach out to your admin for assistance
                    </p>
                }
            />
        );
    }

    return (
        <Grid container justifyContent={"center"} paddingTop={10}>
            <Grid item width={"100%"} minWidth={800} paddingBottom={10}>
                <div style={{ textAlign: "center" }}>
                    <h1>Upload your invoice for {organization.name}</h1>
                    {tokenInfo && (
                        <p>
                            {tokenInfo.name} has invited{" "}
                            <Chip
                                sx={{ margin: 1, padding: 1 }}
                                icon={
                                    <EmailOutlinedIcon
                                        style={{ color: "#4285F4" }}
                                    />
                                }
                                label={tokenInfo.vendor_email}
                            />
                            to invoice for project{" "}
                            <Chip
                                sx={{ margin: 1, padding: 1 }}
                                icon={
                                    <NumbersRoundedIcon
                                        style={{ color: "#27C77E" }}
                                    />
                                }
                                label={tokenInfo.docket}
                            />
                            .
                        </p>
                    )}
                </div>
                <InvoiceFormMulti publicId={publicId} />
            </Grid>
        </Grid>
    );
}
